'use client';

import * as React from 'react';
import classNames from 'classnames';
import './styles.scss';

export interface ILayoutFormProps {
  children: React.ReactNode;
  layout?: 'default' | 'details' | 'filter' | 'api';
  className?: string;
}

const LayoutForm: React.FunctionComponent<ILayoutFormProps> = (props) => {
  return (
    <div
      className={classNames(
        'layout-form',
        {
          ['layout-default']: props.layout === 'default' || !props.layout,
          ['layout-details']: props.layout === 'details',
          ['layout-filter']: props.layout === 'filter',
          ['layout-api']: props.layout === 'api',
        },
        props.className,
      )}
    >
      {props.children}
    </div>
  );
};

LayoutForm.displayName = 'LayoutForm';

export default LayoutForm;
